// Open link in newtab
var links = document.links;
for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
  if (links[i].hostname !== window.location.hostname) {
    links[i].target = '_blank';
    links[i].rel = 'noreferrer noopener';
  }
} 


// Smooth auto scroll slider for each instance
document.addEventListener('DOMContentLoaded', function () {
  // Select all elements with a dynamic ID that matches 'smoothscroll-{section.id}'
  document.querySelectorAll('[id^="smoothscroll"]').forEach(function (slider) {
    new Splide(slider, {
      type: 'loop',
      drag: 'free',
      focus: 'center',
      direction: slider.getAttribute('data-direction'),
      arrows: false,
      autoWidth: true,
      pagination: false,
      perPage: 4,
      autoScroll: {
        speed: 0,
      },
    }).mount(window.splide.Extensions);
  });
});

 
// PDP Accordion toggle 
$(document).ready(function () {
  $('.about__accordion-toggle').on('click', function () {
    const parentLi = $(this).closest('li');
    const answer = parentLi.find('.answer');

    // Close other open accordions (optional – remove if not needed)
    parentLi
      .siblings('.active')
      .removeClass('active')
      .find('.answer')
      .slideUp(300);

    // Toggle current
    parentLi.toggleClass('active');
    answer.stop(true, true).slideToggle(300);
  });
});


// Quick view Js
document.addEventListener("click", function(e) {
  const header = e.target.closest(".abz-accordion-header");
  if (!header) return;

  const item = header.closest(".abz-accordion-item");
  const content = item.querySelector(".abz-accordion-content");
  const iconWrapper = item.querySelector(".abz-accordion-icon");

  const plusIcon = `
    <svg class="icon icon-plus" width="14" height="15" viewBox="0 0 14 15" fill="none">
      <path d="M6 6.5V0.5H8V6.5H14V8.5H8V14.5H6V8.5H0V6.5H6Z" fill="currentColor"/>
    </svg>
  `;

  const minusIcon = `
    <svg class="icon icon-minus" width="14" height="3" viewBox="0 0 14 3" fill="none">
      <path d="M6 0.5H8H14V2.5H8H6H0V0.5H6Z" fill="currentColor"/>
    </svg>
  `;

  const isOpen = item.classList.contains("active");

  // Close all
  document.querySelectorAll(".abz-accordion-item").forEach(el => {
    el.classList.remove("active");
    const c = el.querySelector(".abz-accordion-content");
    const i = el.querySelector(".abz-accordion-icon");

    c.style.maxHeight = null;
    i.innerHTML = plusIcon;
  });

  // Open clicked
  if (!isOpen) {
    item.classList.add("active");
    content.style.maxHeight = content.scrollHeight + "px";
    iconWrapper.innerHTML = minusIcon;
  }
});




// document.addEventListener('DOMContentLoaded', function() {
//   // Get the checkbox element using its ID
//   var availabilityCheckbox = document.getElementById('Filter-Disponibilità-1');
  
//   // Check if the checkbox exists
//   if (availabilityCheckbox) {
//     // Ensure the checkbox is checked on page load
//     availabilityCheckbox.checked = true;

//     // Listen for changes in case the user tries to uncheck it
//     availabilityCheckbox.addEventListener('change', function() {
//       if (!availabilityCheckbox.checked) {
//         // Force it to be checked again if the user tries to uncheck
//         availabilityCheckbox.checked = true;
//       }
//     });
//   }
// });





document.addEventListener('DOMContentLoaded', function() {
  // Get the checkbox element by its ID
  var availabilityCheckbox = document.getElementById('Filter-Disponibilità-1');
  
  // Check if the checkbox exists
  if (availabilityCheckbox) {
    // Ensure the checkbox is checked on page load (even after refresh)
    availabilityCheckbox.checked = true;

    // Store in localStorage to remember the checkbox state
    localStorage.setItem('availabilityCheckboxChecked', 'true');

    // Prevent the checkbox from being unchecked by the user
    availabilityCheckbox.addEventListener('change', function() {
      if (!availabilityCheckbox.checked) {
        // Force it to be checked again if the user tries to uncheck
        availabilityCheckbox.checked = true;
      }
    });
  }
});

// Reapply the checked state on page load (from localStorage)
window.addEventListener('load', function() {
  var availabilityCheckbox = document.getElementById('Filter-Disponibilità-1');

  // Check if we have a saved state in localStorage
  if (availabilityCheckbox && localStorage.getItem('availabilityCheckboxChecked') === 'true') {
    availabilityCheckbox.checked = true;
  }
});